import React, { FunctionComponent, useMemo, useState } from 'react';
import { Utils } from 'record-it-utils/utils/Utils/Utils';
import {
  Breadcrumb,
  BreadcrumbsContext,
  BreadcrumbsContextValue
} from '../../context/BreadcrumbsContext';
import { prepareProps } from '../../utils/propUtils';

export type BreadcrumbsProviderProps = {
  initialBreadcrumbs?: Array<Breadcrumb>;
};

export const BreadcrumbsProvider: FunctionComponent<BreadcrumbsProviderProps> =
  React.memo((props) => {
    const { initialBreadcrumbs, children } = prepareProps({ props });

    const [breadcrumbs, setBreadcrumbs] = useState(initialBreadcrumbs ?? []);

    const contextValue: BreadcrumbsContextValue = useMemo(() => {
      return {
        breadcrumbs,
        setBreadcrumbs: (newBreadCrumbs) => {
          // only update the breadcrumbs if it's a really different value, not just a different instance
          if (!Utils.isDeepEqual(newBreadCrumbs, breadcrumbs)) {
            setBreadcrumbs(newBreadCrumbs);
          }
        }
      };
    }, [breadcrumbs, setBreadcrumbs]);

    return (
      <BreadcrumbsContext.Provider value={contextValue}>
        {children}
      </BreadcrumbsContext.Provider>
    );
  });
